// constants
import { DashboardActionTypes } from './constants';
import {
    DashboardMainInfo as DashboardMainInfoDataType,
    ReportReadyList as ReportReadyListDataType,
    PatientList as PatientListDataType,
} from 'src/types/dashboard';

export type DashboardActionType = {
    type:
        | DashboardActionTypes.API_RESPONSE_SUCCESS
        | DashboardActionTypes.API_RESPONSE_ERROR
        | DashboardActionTypes.GET_DASHBOARD_MAIN
        | DashboardActionTypes.GET_REPORT_READY
        | DashboardActionTypes.GET_PATIENT_LIST
        | DashboardActionTypes.GET_CATEGORY_SALES
        | DashboardActionTypes.GET_CATEGORY_YEARLY_SALES
        | DashboardActionTypes.RESET
        | DashboardActionTypes.RESET_SUCCESS
        | DashboardActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const dashboardApiResponseSuccess = (
    actionType: string,
    data: DashboardMainInfoDataType[] | ReportReadyListDataType[] | PatientListDataType | [],
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DashboardActionType => ({
    type: DashboardActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const dashboardApiResponseError = (
    actionType: string,
    data: DashboardMainInfoDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DashboardActionType => ({
    type: DashboardActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const getDashboardMainInfo = (params: any): DashboardActionType => ({
    type: DashboardActionTypes.GET_DASHBOARD_MAIN,
    payload: params,
});

export const getReportReadyList = (params: any): DashboardActionType => ({
    type: DashboardActionTypes.GET_REPORT_READY,
    payload: params,
});

export const getPatientList = (params: any): DashboardActionType => ({
    type: DashboardActionTypes.GET_PATIENT_LIST,
    payload: params,
});

export const getCategorySales = (params: any): DashboardActionType => ({
    type: DashboardActionTypes.GET_CATEGORY_SALES,
    payload: params,
});

export const getCategoryYearlySales = (params: any): DashboardActionType => ({
    type: DashboardActionTypes.GET_CATEGORY_YEARLY_SALES,
    payload: params,
});

export const resetDashboard = (): DashboardActionType => ({
    type: DashboardActionTypes.RESET,
    payload: {},
});

export const resetDashboardSuccess = (): DashboardActionType => ({
    type: DashboardActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetDashboardError = (): DashboardActionType => ({
    type: DashboardActionTypes.RESET_ERROR,
    payload: {},
});
